import { render } from "./InvoiceItemsInput.vue?vue&type=template&id=66385a6f"
import script from "./InvoiceItemsInput.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__